import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import logo from "../../assets/images/logo.jpg"
import bgImage from "../../assets/images/loginBg.jpg"
import { fetchData, FetchPutData } from "utils/Common_api_functions"
import Loader from "components/Loader/loader"
import Swal from "sweetalert2"
import { Col, Row } from "reactstrap"

/* ───────── Radio Group ───────── */
const RadioGroup = ({ label, name, value, onChange }) => (
  <div style={styles.radioGroup}>
    <label style={styles.label}>{label}</label>
    <div style={styles.radioRow}>
      {[1, 0].map(opt => (
        <label key={opt} style={styles.radioLabel}>
          <input
            type="radio"
            name={name}
            checked={value === opt}
            onChange={() => onChange(name, opt)}
            style={{ display: "none" }}
          />
          <span
            style={{
              ...styles.radioDot,
              background: value === opt ? "#3d6eb5" : "transparent",
            }}
          />
          {opt === 1 ? "Yes" : "No"}
        </label>
      ))}
    </div>
  </div>
)

/* ───────── Main Component ───────── */
const FeedbackForm = () => {
  const { token } = useParams()
  const [loading, setLoading] = useState(false)
  const [employee, setEmployee] = useState({})

  const [inspection, setInspection] = useState({
    isWindowCleaning: "",
    hasCleanedOutsideWindow: "",
    hasCleanedInsideWindow: "",
    isBigClean: "",
    isWorkSatisfied: "",
  })

  const [authorisation, setAuthorisation] = useState({
    checkedAndAuthorisedBy: "",
    position: "",
    signature: "",
  })

  useEffect(() => {
    if (token) {
      getEmployeeName()
    }
  }, [token])

  async function getEmployeeName() {
    const APIdata = await fetchData(setLoading, `feedback/${token}`)
    if (APIdata?.success) {
      setEmployee(APIdata?.data)
      setAuthorisation({
        checkedAndAuthorisedBy: APIdata?.data?.location?.contactPerson,
      })
    }
  }

  const handleRadioChange = (name, value) => {
    setInspection(prev => ({ ...prev, [name]: value }))
  }

  const handleAuthChange = e => {
    const { name, value } = e.target
    setAuthorisation(prev => ({ ...prev, [name]: value }))
  }

  const validateForm = () => {
    // Inspection validation
    for (const [key, value] of Object.entries(inspection)) {
      if (value === "" || value === null || value === undefined) {
        Swal.fire({
          icon: "warning",
          title: "Incomplete Form",
          text: "Please answer all service checklist questions.",
        })
        return false
      }
    }

    // Authorisation validation
    if (!authorisation.checkedAndAuthorisedBy?.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Name",
        text: "Please enter Checked & Authorised By name.",
      })
      return false
    }

    if (!authorisation.position?.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Position",
        text: "Please enter your position.",
      })
      return false
    }

    if (!authorisation.signature?.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Signature",
        text: "Please enter signature.",
      })
      return false
    }

    return true
  }

  const handleSubmit = async () => {
    if (!validateForm()) return

    const payload = {
      ...inspection,
      ...authorisation,
    }

    const res = await FetchPutData(setLoading, "feedback", token, payload)

    if (res?.data?.success) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Feedback submitted successfully",
        confirmButtonText: "Close",
      }).then(() => {
        setInspection({
          isWindowCleaning: "",
          hasCleanedOutsideWindow: "",
          hasCleanedInsideWindow: "",
          isBigClean: "",
          isWorkSatisfied: "",
        })

        setAuthorisation({
          checkedAndAuthorisedBy: "",
          position: "",
          signature: "",
        })

        // 🔥 Close the tab/window
        window.close()
      })
    } else {
      Swal.fire("Error", res?.response?.data?.message, "error")
    }
  }

  return (
    <div style={styles.page(bgImage)}>
      {loading && <Loader />}
      <div style={styles.overlay} />

      <div style={styles.card}>
        <div style={styles.cardHeader}>
          <div className="p-3 bg-white rounded-4">
            <img src={logo} alt="logo" style={{ width: "250px" }} />
          </div>
          <h1 style={styles.heading}>Customer Statisfaction Report</h1>
          <p style={styles.subtext}>Window Cleaning Service</p>
        </div>

        <Row className="mb-3">
          <Col xl={6}>
            <p className="mb-0">Location </p>
            <h4 className="mt-2">{employee?.location?.name}</h4>
            <h6 className="mt-2">{employee?.location?.address}</h6>
          </Col>
          <Col xl={6}>
            <p className="mb-0">Employee Name </p>
            <h4 className="mt-2">{employee?.employee?.name}</h4>
          </Col>
        </Row>

        {/* Service Checklist */}
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Service Checklist</h3>

          <Row>
            <Col md={6}>
              <RadioGroup
                label="Window Cleaning"
                name="isWindowCleaning"
                value={inspection.isWindowCleaning}
                onChange={handleRadioChange}
              />
            </Col>
            <Col md={6}>
              <RadioGroup
                label="Outside Windows Cleaned"
                name="hasCleanedOutsideWindow"
                value={inspection.hasCleanedOutsideWindow}
                onChange={handleRadioChange}
              />
            </Col>
            <Col md={6}>
              <RadioGroup
                label="Inside Windows Cleaned"
                name="hasCleanedInsideWindow"
                value={inspection.hasCleanedInsideWindow}
                onChange={handleRadioChange}
              />
            </Col>
            <Col md={6}>
              <RadioGroup
                label="Big / Deep Clean"
                name="isBigClean"
                value={inspection.isBigClean}
                onChange={handleRadioChange}
              />
            </Col>
            <Col md={6}>
              <RadioGroup
                label="Satisfied With Work"
                name="isWorkSatisfied"
                value={inspection.isWorkSatisfied}
                onChange={handleRadioChange}
              />
            </Col>
          </Row>
        </div>

        {/* Authorisation */}
        <div style={styles.section}>
          <h3 style={styles.sectionTitle}>Checked & Authorised By</h3>

          <Row>
            <Col md={6}>
              <input
                style={styles.input}
                name="checkedAndAuthorisedBy"
                placeholder="Full Name"
                value={authorisation?.checkedAndAuthorisedBy}
                onChange={handleAuthChange}
              />
            </Col>
            <Col md={6}>
              <input
                style={styles.input}
                name="position"
                placeholder="Position"
                value={authorisation?.position}
                onChange={handleAuthChange}
              />
            </Col>
          </Row>

          <input
            style={styles.input}
            name="signature"
            placeholder="Signature"
            value={authorisation?.signature}
            onChange={handleAuthChange}
          />
        </div>

        <button
          className="btn w-100 text-center py-3 rounded-4 fs-5 fw-bold btn-blue"
          onClick={handleSubmit}
        >
          Submit Feedback →
        </button>
      </div>
    </div>
  )
}

export default FeedbackForm

/* ───────── Styles ───────── */
const styles = {
  page: bg => ({
    minHeight: "100vh",
    backgroundImage: `url(${bg})`,
    backgroundSize: "cover",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  }),
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.65)",
  },
  card: {
    background: "rgba(0,0,0,0.75)",
    padding: "36px",
    borderRadius: "22px",
    width: "100%",
    maxWidth: "750px",
    color: "#fff",
    zIndex: 1,
  },
  cardHeader: { textAlign: "center", marginBottom: "24px" },
  heading: { fontSize: "24px", fontWeight: 700, marginTop: "30px" },
  subtext: { fontSize: "14px", opacity: 0.8 },
  label: { fontSize: "12px", color: "#ccc", marginBottom: "6px" },
  textarea: {
    width: "100%",
    borderRadius: "14px",
    padding: "14px",
    border: "1px solid #444",
    background: "rgba(255,255,255,0.06)",
    color: "#fff",
    marginBottom: "24px",
  },
  section: { marginBottom: "24px" },
  sectionTitle: {
    fontSize: "15px",
    fontWeight: 700,
    marginBottom: "14px",
    borderBottom: "1px solid rgba(255,255,255,0.2)",
    paddingBottom: "6px",
  },
  radioGroup: { marginBottom: "12px" },
  radioRow: { display: "flex", gap: "24px", marginTop: "6px" },
  radioLabel: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    cursor: "pointer",
  },
  radioDot: {
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    border: "2px solid #3d6eb5",
  },
  input: {
    width: "100%",
    padding: "12px",
    borderRadius: "12px",
    border: "1px solid #444",
    background: "rgba(255,255,255,0.9)",
    color: "#000",
    marginBottom: "12px",
  },
}
